<template>
  <b-form-group class="custom-input text-left">
    <div style="max-width: 800px" class="mx-auto">
      <div class="d-flex justify-content-between">
        <label v-if="label.length > 0" class="font-label" :for="id">{{
          label
        }}</label>
        <div class="flex-grow-1 d-flex justify-content-end">
          <slot name="label-right"></slot>
        </div>
      </div>
      <b-form-input
        class="base-input"
        :id="id"
        :ref="id"
        :value="field.$model"
        @input="updateField"
        :state="state"
        :type="type"
        :placeholder="placeHolder"
        :autofocus="autofocus"
        @keyup.enter="$emit('keyupEnter')"
      />
      <slot></slot>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    id: { type: String, required: true },
    type: { type: String, required: true },
    field: { type: Object, required: true },
    state: { type: [Boolean] },
    autofocus: { type: [Boolean], default: () => false },
    placeHolder: { type: String },
    label: { type: String, default: () => "" },
  },
  data() {
    return {
      event: "update",
    };
  },
  methods: {
    updateField(event) {
      this.$emit("update", event);
    },
  },
};
</script>
<style scoped>
.base-input::placeholder {
  transform: translateY(var(--placeholder-translate)); /* adjust */
  display: inline-block;
}

/* Chrome / Safari */
.base-input::-webkit-input-placeholder {
  transform: translateY(var(--placeholder-translate));
  display: inline-block;
}

/* Firefox */
.base-input::-moz-placeholder {
  transform: translateY(var(--placeholder-translate));
  display: inline-block;
}

/* Edge / IE */
.base-input:-ms-input-placeholder {
  transform: translateY(var(--placeholder-translate));
  display: inline-block;
}
</style>
